import Carousel from './carousel';
import Video from './video';
import VideoThumbnail from './video-thumbnail';

export { Video, VideoThumbnail };

export default Carousel;
